import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutomationReceivedRules,
  ITicketAutomationReceivedRules,
  ITicketAutomationReceivedRulesList,
} from "../models/ticket-automation-received-rules";

const TICKET_AUTOMATION_RECEIVED_RULES_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationReceivedRule/";

export const createAutomationReceivedRule = (
  item: INewTicketAutomationReceivedRules,
) => {
  return GlobalAxios.post(TICKET_AUTOMATION_RECEIVED_RULES_ROUTE, item);
};

export const getAutomationReceivedRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedRules>(
    TICKET_AUTOMATION_RECEIVED_RULES_ROUTE + id,
  );
};

export const updateAutomationReceivedRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedRules;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUTOMATION_RECEIVED_RULES_ROUTE + id, item);
};

export const automationReceivedRuleList = (params?: any) => {
  return GlobalAxios.get<ITicketAutomationReceivedRulesList[]>(
    TICKET_AUTOMATION_RECEIVED_RULES_ROUTE + "list",
    { params },
  );
};
